/* eslint-disable react/display-name */
import React from 'react'
import style from './index.scss'
import withAngleMaskClasses, {
  AngleMaskClassesProps,
  AngleMaskWrapperProps,
} from './with-angle-mask-classes'

const withAngleClasses = <P extends AngleMaskClassesProps>(
  Component: React.ComponentType<P>
): React.FC<AngleMaskWrapperProps<P>> => (props: AngleMaskWrapperProps<P>) => (
  // NB: Fixing this was very bad effort to value
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  <Component angleClasses={style} {...props} />
)

export { withAngleClasses, withAngleMaskClasses }
